module.exports = __webpack_public_path__ + "static/media/undraw_Terms_re_6ak4.1c994481.png";